export default "__VITE_ASSET__DdG1TCIO__";